import { gql } from '../../../apollo/__generated__';

export const CREATE_TICKET_TRANSACTION = gql(`
  mutation CreateTicketTransaction($createTicketTransactionInput: CreateTicketTransactionInput!) {
    createTicketTransaction(createTicketTransactionInput: $createTicketTransactionInput) 
  }
`);
